<template>
    <v-text-field
      :hint="nombre"
      persistent-hint
      readonly
      :value="horasContrato"
      class="v-input--is-focused"
      :class="clase"
    >
      <template slot="append" v-if="horasContrato < 0 || horasContrato == '>20'">
        <v-tooltip
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              style="cursor: help"
            >
              <v-icon
                class="ml-1"
                :color="contrato.nivelAlertaContrato.color"
                v-if="horasContrato < 0"
              >
                {{ contrato.nivelAlertaContrato.icono }}
              </v-icon>
              <v-icon
                class="ml-1"
                color="default"
                v-else
              >
                mdi-information-outline
              </v-icon>
            </v-btn>
          </template>
          <span v-if="horasContrato < 0">
            Horas contratadas:
            {{ horasContratadas }} horas
          </span>
          <span v-else>
            <!-- Atención! No facilitar esta información al cliente.
            <br>
            {{ horasContratoTooltip }} horas -->
            Más de 20 horas disponibles
          </span>
        </v-tooltip>
      </template>
    </v-text-field>
</template>
<script>
export default {
    name: 'ResumenContrato',
    props: ['clase', 'nombre', 'contrato'],
    data() {
      return {
        horasContratoTooltip: null
      }
    },
    methods: {
      
    },
    mounted(){

    },
    computed: {
      horasContrato(){
        if(this.contrato){
          console.log(this.contrato);
          if((this.contrato.contrato_id !== 3 && this.contrato.contrato_id !== 8) && this.contrato.horas > 20){
            this.horasContratoTooltip = this.contrato.horas;
            return '>20';
          }
          return this.contrato.horas;
        }
        return 0;
        
      },
      horasContratadas(){
        return this.contrato ? this.contrato.horasContratadas : 0;
      }
    }
    
}
</script>